import {ChangeDetectionStrategy, Component, HostBinding, inject, input, Input, OnInit} from '@angular/core';
import {StoryblokService} from '@core/services/storyblok.service';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {StoryblokDirective} from '@core/directives/storyblok.directive';

import {StoryblokBaseComponent} from '../storyblok-base.component';
import {
  SpotObj,
  StoryblokSpotComponent
} from '@modules/storyblok/components/storyblok-spots/storyblok-spot/storyblok-spot.component';

@Component({
  selector: 'app-storyblok-spots',
  templateUrl: './storyblok-spots.component.html',
  styleUrls: ['./storyblok-spots.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective, StoryblokSpotComponent]
})
export class StoryblokSpotsComponent extends StoryblokBaseComponent implements OnInit {
  private storyblokService = inject(StoryblokService);
  private storyblokStylingService = inject(StoryblokStylingService);


  spots: { spot: SpotObj, col: string, originalObj: any, _editable: any }[] = [];

  @Input()
  set body(body: any) {
    this.spots = body.map((d: any) => {
      return {
        spot: this.getSpot(d),
        col: this.getSpotCol(d),
        originalObj: d
      }
    });
  }

  readonly _editable = input<any>();
  readonly general_styling = input<any>();

  @Input()
  set elementId(value: any) {
    this.hostElementId = value
  }

  @HostBinding('attr.id') hostElementId: any

  @HostBinding('class') class: any;

  ngOnInit(): void {
    this.class = this.storyblokStylingService.getClassList(this.general_styling(), undefined, {'col-': 12}, this.col());
  }

  getSpotCol(spot: any) {
    return this.storyblokService.getCols(spot.col);
  }

  protected getImageSize(spot: any): { imgHeight: number | undefined, imgWidth: number | undefined } {
    const filename = spot.backgroundImage.filename as string;
    return this.storyblokService.getImageSize(filename);
  }

  getSpot(spot: any): SpotObj {
    const {imgWidth, imgHeight} = this.getImageSize(spot);

    return {
      title: spot.title,
      description: spot.description,
      ctaText: spot.ctaText,
      ctaLink: spot.ctaLink.cached_url,
      ctaDesign: spot.ctaDesign,
      backgroundImage: spot.backgroundImage?.filename,
      height: spot.height,
      imgHeight,
      imgWidth
    };
  }

}
